module.exports = __webpack_public_path__ + "media/images/faces/face19-775c635f9bb34a3e57cc412b0f4b4eb0.jpg";